import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { DataSyncItem, OptimizelyProduct } from '../../../types/DataSyncItem';
import React from 'react';
import styles from './DataSyncIcons.module.sass';
import { IconSize, ObjectIcon } from './ObjectIcon';

interface DataSyncIconsProps {
  dataSync?: DataSyncItem;
}

const DataSyncIcons: React.FC<DataSyncIconsProps> = ({dataSync}) => {
  const altText = dataSync?.source.object.object_display_name || dataSync?.source.object.object_name || '';
  let sourceIcon: React.ReactNode;
  if (dataSync?.source.object.object_icon_url) {
    sourceIcon = <ObjectIcon size={IconSize.MEDIUM} src={dataSync.source.object.object_icon_url} alt={altText} />;
  } else if (dataSync?.source.product === OptimizelyProduct.CMP) {
    sourceIcon = <ObjectIcon size={IconSize.MEDIUM} src={'/assets/cmp.svg'} alt={altText} />;
  } else {
    sourceIcon = <ObjectIcon size={IconSize.MEDIUM} src={'/assets/data_platform.svg'} alt={altText} />;
  }

  const destinationIcon = dataSync?.destination.product === OptimizelyProduct.CGR ?
    <ObjectIcon size={IconSize.MEDIUM} src="/assets/content_graph.svg" alt="Optimizely Graph"/> :
    <ObjectIcon size={IconSize.MEDIUM} src="/assets/data_platform.svg" alt="Optimizely"/>;

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>{sourceIcon}</div>
      <Icon icon={IconNames.CARET_RIGHT}/>
      <div className={styles.iconWrapper}>{destinationIcon} </div>
    </div>
  );
};

export default DataSyncIcons;
